import { getApp, type FirebaseApp } from 'firebase/app'
import firebase from 'firebase/compat/app'
import { assertFirebaseAuthDomainSafe, requireProcessEnv } from './env'

const authDomain = requireProcessEnv('VUE_APP_FIREBASE_AUTHDOMAIN')
assertFirebaseAuthDomainSafe(authDomain)

const firebaseConfig = {
  apiKey: requireProcessEnv('VUE_APP_FIREBASE_APIKEY'),
  authDomain,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: requireProcessEnv('VUE_APP_FIREBASE_PROJECTID'),
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
}

/**
 * 既定 App を 1 回だけ作る。
 * leftover の `firebase.auth()` / `firebase.firestore()` / `$firebase.db` は
 * compat 側の `[DEFAULT]` マップを見る。modular `initializeApp()` だけでは
 * そこに載らず `app-compat/no-app` になる。compat `initializeApp` は
 * modular の DEFAULT も同時に登録する。
 */
export function getFirebaseApp(): FirebaseApp {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }
  return getApp()
}

export { firebaseConfig }
